export var AfriexErrorCode;
(function (AfriexErrorCode) {
    AfriexErrorCode["AccountNotFound"] = "ACCOUNT_NOT_FOUND";
    AfriexErrorCode["AuthenticationError"] = "AUTHENTICATION_ERROR";
    AfriexErrorCode["CheckoutSessionNotFound"] = "CHECKOUT_SESSION_NOT_FOUND";
    AfriexErrorCode["InvalidCheckoutLinkRequest"] = "INVALID_CHECKOUT_LINK_REQUEST";
    AfriexErrorCode["CheckoutSessionExpired"] = "CHECKOUT_SESSION_EXPIRED";
    AfriexErrorCode["BalanceInsufficient"] = "BALANCE_INSUFFICIENT";
    AfriexErrorCode["DailyVolumeLimitExceeded"] = "DAILY_VOLUME_LIMIT_EXCEEDED";
    AfriexErrorCode["BusinessCustomerNotFound"] = "BUSINESS_CUSTOMER_NOT_FOUND";
    AfriexErrorCode["BusinessPaymentMethodNotFound"] = "BUSINESS_PAYMENT_METHOD_NOT_FOUND";
    AfriexErrorCode["BusinessTransactionNotFound"] = "BUSINESS_TRANSACTION_NOT_FOUND";
    AfriexErrorCode["BusinessKeyNotFound"] = "BUSINESS_KEY_NOT_FOUND";
    AfriexErrorCode["BusinessUpdateFailed"] = "BUSINESS_UPDATE_FAILED";
    AfriexErrorCode["BusinessUserUpdateFailed"] = "BUSINESS_USER_UPDATE_FAILED";
    AfriexErrorCode["BusinessTransactionUpdateFailed"] = "BUSINESS_TRANSACTION_UPDATE_FAILED";
    AfriexErrorCode["CorridorBlocked"] = "CORRIDOR_BLOCKED";
    AfriexErrorCode["CurrencyCodeNotAllowed"] = "CURRENCY_CODE_NOT_ALLOWED";
    AfriexErrorCode["CurrencyNotFound"] = "CURRENCY_NOT_FOUND";
    AfriexErrorCode["CountryNotFound"] = "COUNTRY_NOT_FOUND";
    AfriexErrorCode["CountryNotSupported"] = "COUNTRY_NOT_SUPPORTED";
    AfriexErrorCode["DailyCountLimitExceeded"] = "DAILY_COUNT_LIMIT_EXCEEDED";
    AfriexErrorCode["EmailAlreadyExists"] = "EMAIL_ALREADY_EXISTS";
    // The email is already an active member of another business organization.
    // A single email cannot belong to more than one organization.
    AfriexErrorCode["EmailBelongsToAnotherOrganization"] = "EMAIL_BELONGS_TO_ANOTHER_ORGANIZATION";
    // The matched organization is currently unavailable (e.g. its owner account
    // is suspended). New members cannot be added and its domain cannot create a
    // new organization until the owner is reinstated.
    AfriexErrorCode["OrganizationUnavailable"] = "ORGANIZATION_UNAVAILABLE";
    // An organization already owns this corporate email domain. Unlike
    // EmailBelongsToAnotherOrganization, the email itself is new.
    AfriexErrorCode["OrganizationAlreadyExists"] = "ORGANIZATION_ALREADY_EXISTS";
    AfriexErrorCode["InviteAlreadySent"] = "INVITE_ALREADY_SENT";
    AfriexErrorCode["CustomerAlreadyExists"] = "CUSTOMER_ALREADY_EXISTS";
    AfriexErrorCode["DeviceIDMismatch"] = "DEVICE_ID_MISMATCH";
    AfriexErrorCode["DeviceTypeMismatch"] = "DEVICE_TYPE_MISMATCH";
    AfriexErrorCode["DeviceCountryMismatch"] = "DEVICE_COUNTRY_MISMATCH";
    AfriexErrorCode["DuplicateRequest"] = "DUPLICATE_REQUEST";
    AfriexErrorCode["InvalidLedgerProvided"] = "INVALID_LEDGER_PROVIDED";
    AfriexErrorCode["InvalidBankName"] = "INVALID_BANK_NAME";
    AfriexErrorCode["InvalidBankSwiftCode"] = "INVALID_BANK_SWIFT_CODE";
    AfriexErrorCode["InvalidBankAccountNumber"] = "INVALID_BANK_ACCOUNT_NUMBER";
    AfriexErrorCode["InvalidBankAccountName"] = "INVALID_BANK_ACCOUNT_NAME";
    AfriexErrorCode["InvalidBankAccountPhone"] = "INVALID_BANK_ACCOUNT_PHONE";
    AfriexErrorCode["InvalidBusinessKeyRequest"] = "INVALID_BUSINESS_KEY_REQUEST";
    AfriexErrorCode["InvalidBusinessAPIRequest"] = "INVALID_BUSINESS_API_REQUEST";
    AfriexErrorCode["InvalidBusinessCustomerRequest"] = "INVALID_BUSINESS_CUSTOMER_REQUEST";
    AfriexErrorCode["InvalidBusinessRoleRequest"] = "INVALID_BUSINESS_ROLE_REQUEST";
    AfriexErrorCode["InvalidScheduleProvided"] = "INVALID_SCHEDULE_PROVIDED";
    AfriexErrorCode["InvalidBusinessPermissionRequest"] = "INVALID_BUSINESS_PERMISSION_REQUEST";
    AfriexErrorCode["InvalidBusinessPaymentBatchRequest"] = "INVALID_BUSINESS_PAYMENT_BATCH_REQUEST";
    AfriexErrorCode["InvalidBusinessCustomerId"] = "INVALID_BUSINESS_CUSTOMER_ID";
    AfriexErrorCode["InvalidBusinessPaymentMethodId"] = "INVALID_BUSINESS_PAYMENT_METHOD_ID";
    AfriexErrorCode["InvalidBusinessTransactionId"] = "INVALID_BUSINESS_TRANSACTION_ID";
    AfriexErrorCode["InvalidBusinessTransactionRequest"] = "INVALID_BUSINESS_TRANSACTION_REQUEST";
    AfriexErrorCode["MakerCheckerActionNotAuthorized"] = "MAKER_CHECKER_ACTION_NOT_AUTHORIZED";
    AfriexErrorCode["FeatureNotAvailableForBusiness"] = "FEATURE_NOT_AVAILABLE_FOR_BUSINESS";
    AfriexErrorCode["InvalidBusinessPaymentMethodRequest"] = "INVALID_BUSINESS_PAYMENT_METHOD_REQUEST";
    AfriexErrorCode["InvalidBusinessStaffRequest"] = "INVALID_BUSINESS_STAFF_REQUEST";
    AfriexErrorCode["InvalidBusinessStaffInviteRequest"] = "INVALID_BUSINESS_STAFF_INVITE_REQUEST";
    AfriexErrorCode["InvalidBusinessFeeRequest"] = "INVALID_BUSINESS_FEE_REQUEST";
    AfriexErrorCode["DuplicateBusinessFee"] = "DUPLICATE_BUSINESS_FEE";
    AfriexErrorCode["InvalidFeatureRequest"] = "INVALID_FEATURE_REQUEST";
    AfriexErrorCode["InvalidBusinessLimitRequest"] = "INVALID_BUSINESS_LIMIT_REQUEST";
    AfriexErrorCode["BusinessLimitExceeded"] = "BUSINESS_LIMIT_EXCEEDED";
    AfriexErrorCode["InvalidRatePromoRequest"] = "INVALID_RATE_PROMO_REQUEST";
    AfriexErrorCode["InvalidAccountAddress"] = "INVALID_ACCOUNT_ADDRESS";
    AfriexErrorCode["InvalidTransactionPurpose"] = "INVALID_TRANSACTION_PURPOSE";
    AfriexErrorCode["InvalidTransactionType"] = "INVALID_TRANSACTION_TYPE";
    AfriexErrorCode["InvalidWalletActionType"] = "INVALID_WALLET_ACTION_TYPE";
    AfriexErrorCode["InvalidTransactionChannel"] = "INVALID_TRANSACTION_CHANNEL";
    AfriexErrorCode["InvalidJournalTransaction"] = "INVALID_JOURNAL_TRANSACTION";
    AfriexErrorCode["InvalidInvoice"] = "INVALID_INVOICE";
    AfriexErrorCode["InvalidAccountEmail"] = "INVALID_ACCOUNT_EMAIL";
    AfriexErrorCode["InvalidDeviceId"] = "INVALID_DEVICE_ID";
    AfriexErrorCode["InvalidDeviceOs"] = "INVALID_DEVICE_OS";
    AfriexErrorCode["InvalidDeviceCountry"] = "INVALID_DEVICE_COUNTRY";
    AfriexErrorCode["InvalidInput"] = "INVALID_INPUT";
    AfriexErrorCode["InvalidIPAddress"] = "INVALID_IP_ADDRESS";
    AfriexErrorCode["InvalidKYCDocumentType"] = "INVALID_KYC_DOCUMENT_TYPE";
    AfriexErrorCode["InvalidOnboardingProcessor"] = "INVALID_ONBOARDING_PROCESSOR";
    AfriexErrorCode["HumanVerificationFailed"] = "HUMAN_VERIFICATION_FAILED";
    AfriexErrorCode["InvalidAuthProcessor"] = "INVALID_AUTH_PROCESSOR";
    AfriexErrorCode["InvalidReferralCodeProvided"] = "INVALID_REFERRAL_CODE_PROVIDED";
    AfriexErrorCode["InvalidReferralTier"] = "INVALID_REFERRAL_TIER";
    AfriexErrorCode["InvalidReferral"] = "INVALID_REFERRAL";
    AfriexErrorCode["ExternalRequestError"] = "EXTERNAL_REQUEST_ERROR";
    AfriexErrorCode["FailedToSaveBusiness"] = "FAILED_TO_SAVE_BUSINESS";
    AfriexErrorCode["NoCurrencyCodeProvided"] = "NO_CURRENCY_CODE_PROVIDED";
    AfriexErrorCode["FailedToCreateVirtualAccount"] = "FAILED_TO_CREATE_VIRTUAL_ACCOUNT";
    AfriexErrorCode["NoPaymentLinkReturned"] = "NO_PAYMENT_LINK_RETURNED";
    AfriexErrorCode["FailedToSaveBusinessUser"] = "FAILED_TO_SAVE_BUSINESS_USER";
    AfriexErrorCode["FailedToCreateBusinessCustomer"] = "FAILED_TO_CREATE_BUSINESS_CUSTOMER";
    AfriexErrorCode["FailedToCreateBusinessPaymentMethod"] = "FAILED_TO_CREATE_BUSINESS_PAYMENT_METHOD";
    AfriexErrorCode["FailedToGenerateBusinessOTP"] = "FAILED_TO_GENERATE_BUSINESS_OTP";
    AfriexErrorCode["FailedToGenerateOTP"] = "FAILED_TO_GENERATE_OTP";
    AfriexErrorCode["FailedToSetupSandbox"] = "FAILED_TO_SETUP_SANDBOX";
    AfriexErrorCode["FailedToSendOTP"] = "FAILED_TO_SEND_OTP";
    AfriexErrorCode["FailedToSendEmail"] = "FAILED_TO_SEND_EMAIL";
    AfriexErrorCode["FailedToSendSMS"] = "FAILED_TO_SEND_SMS";
    AfriexErrorCode["FailedToSendPushNotification"] = "FAILED_TO_SEND_PUSH_NOTIFICATION";
    AfriexErrorCode["FailedToSendSlackMessage"] = "FAILED_TO_SEND_SLACK_MESSAGE";
    AfriexErrorCode["FailedToSaveBusinessAccount"] = "FAILED_TO_SAVE_BUSINESS_ACCOUNT";
    AfriexErrorCode["FailedToUpdateAccount"] = "FAILED_TO_UPDATE_ACCOUNT";
    AfriexErrorCode["FailedToHashPassword"] = "FAILED_TO_HASH_PASSWORD";
    AfriexErrorCode["FailedToSaveTransaction"] = "FAILED_TO_SAVE_TRANSACTION";
    AfriexErrorCode["FailedToCancelScheduledTransaction"] = "FAILED_TO_CANCEL_SCHEDULED_TRANSACTION";
    AfriexErrorCode["FailedToCreateBusinessKey"] = "FAILED_TO_CREATE_BUSINESS_KEY";
    AfriexErrorCode["FailedToVerifyUser"] = "FAILED_TO_VERIFY_USER";
    AfriexErrorCode["FailedToVerifyToken"] = "FAILED_TO_VERIFY_TOKEN";
    AfriexErrorCode["FailedToVerifyBusiness"] = "FAILED_TO_VERIFY_BUSINESS";
    AfriexErrorCode["BusinessNotFound"] = "BUSINESS_NOT_FOUND";
    AfriexErrorCode["BusinessNotFoundForUser"] = "BUSINESS_NOT_FOUND_FOR_USER";
    AfriexErrorCode["BusinessInvoiceNotFound"] = "BUSINESS_INVOICE_NOT_FOUND";
    AfriexErrorCode["BusinessPinResetRequestNotFound"] = "BUSINESS_PIN_RESET_REQUEST_NOT_FOUND";
    AfriexErrorCode["FailedToSaveBusinessInvoice"] = "FAILED_TO_SAVE_BUSINESS_INVOICE";
    AfriexErrorCode["FailedToSaveBusinessCheckout"] = "FAILED_TO_SAVE_BUSINESS_CHECKOUT";
    AfriexErrorCode["FailedToUpdateOnboarding"] = "FAILED_TO_UPDATE_ONBOARDING";
    AfriexErrorCode["FailedToUpdateAccountHistory"] = "FAILED_TO_UPDATE_ACCOUNT_HISTORY";
    AfriexErrorCode["FailedToSaveAccount"] = "FAILED_TO_SAVE_ACCOUNT";
    AfriexErrorCode["FailedToSaveUser"] = "FAILED_TO_SAVE_USER";
    AfriexErrorCode["FailedToGetUserDetails"] = "FAILED_TO_GET_USER_DETAILS";
    AfriexErrorCode["FailedToVerifyOTP"] = "FAILED_TO_VERIFY_OTP";
    AfriexErrorCode["PaymentMethodNotFound"] = "PAYMENT_METHOD_NOT_FOUND";
    AfriexErrorCode["PaymentMethodNotActive"] = "PAYMENT_METHOD_NOT_ACTIVE";
    AfriexErrorCode["FailedToClearSession"] = "FAILED_TO_CLEAR_SESSION";
    AfriexErrorCode["FeesNotFound"] = "FEES_NOT_FOUND";
    AfriexErrorCode["FailedToNotifyBusinessOfOTP"] = "FAILED_TO_NOTIFY_BUSINESS_OF_OTP";
    AfriexErrorCode["FailedToLoadTransactionData"] = "FAILED_TO_LOAD_TRANSACTION_DATA";
    AfriexErrorCode["FailedToCreditLedger"] = "FAILED_TO_CREDIT_LEDGER";
    // The ledger already holds this money movement (its idempotency key is taken
    // in medici_journals), so nothing was written. Not a failure to retry.
    AfriexErrorCode["DuplicateLedgerCredit"] = "DUPLICATE_LEDGER_CREDIT";
    AfriexErrorCode["FailedToDebitLedger"] = "FAILED_TO_DEBIT_LEDGER";
    // A marketplace bid's credit leg failed and reversing its debit failed too,
    // so the wallet is left debited. The bid must stay claimed: retrying it
    // would debit the wallet a second time.
    AfriexErrorCode["MarketplaceBidDebitNotReversed"] = "MARKETPLACE_BID_DEBIT_NOT_REVERSED";
    AfriexErrorCode["InvalidBankInfo"] = "INVALID_BANK_INFO";
    AfriexErrorCode["InvalidCurrencyCode"] = "INVALID_CURRENCY_CODE";
    AfriexErrorCode["InvalidCurrency"] = "INVALID_CURRENCY";
    AfriexErrorCode["InvalidName"] = "INVALID_NAME";
    AfriexErrorCode["InvalidEmail"] = "INVALID_EMAIL";
    AfriexErrorCode["InvalidPassword"] = "INVALID_PASSWORD";
    AfriexErrorCode["InvalidProcessor"] = "INVALID_PROCESSOR";
    AfriexErrorCode["InvalidProcessorName"] = "INVALID_PROCESSOR_NAME";
    AfriexErrorCode["InvalidCountry"] = "INVALID_COUNTRY";
    AfriexErrorCode["InvalidBusinessName"] = "INVALID_BUSINESS_NAME";
    AfriexErrorCode["InvalidBusinessType"] = "INVALID_BUSINESS_TYPE";
    AfriexErrorCode["InvalidBusinessPoolAccountRequest"] = "INVALID_BUSINESS_POOL_ACCOUNT_REQUEST";
    AfriexErrorCode["InvalidOTPProvided"] = "INVALID_OTP_PROVIDED";
    AfriexErrorCode["InvalidPhone"] = "INVALID_PHONE";
    AfriexErrorCode["InvalidTokenProvided"] = "INVALID_TOKEN_PROVIDED";
    AfriexErrorCode["InvalidUserData"] = "INVALID_USER_DATA";
    AfriexErrorCode["InvalidDateOfBirth"] = "INVALID_DATE_OF_BIRTH";
    AfriexErrorCode["PhoneCountryMismatch"] = "PHONE_COUNTRY_MISMATCH";
    AfriexErrorCode["NoNameProvided"] = "NO_NAME_PROVIDED";
    AfriexErrorCode["NoPhoneProvided"] = "NO_PHONE_PROVIDED";
    AfriexErrorCode["NoReferralCodeProvided"] = "NO_REFERRAL_CODE_PROVIDED";
    AfriexErrorCode["NoTokenProvided"] = "NO_TOKEN_PROVIDED";
    AfriexErrorCode["PasswordContainsUserInformation"] = "PASSWORD_CONTAINS_USER_INFORMATION";
    AfriexErrorCode["PasswordTooShort"] = "PASSWORD_TOO_SHORT";
    AfriexErrorCode["PasswordAttemptsExceeded"] = "PASSWORD_ATTEMPTS_EXCEEDED";
    AfriexErrorCode["PhoneNumberTooShort"] = "PHONE_NUMBER_TOO_SHORT";
    AfriexErrorCode["PhoneNumberTooLong"] = "PHONE_NUMBER_TOO_LONG";
    AfriexErrorCode["PhoneNumberAlreadyExists"] = "PHONE_NUMBER_ALREADY_EXISTS";
    AfriexErrorCode["ProcessorBalanceCheckFailed"] = "PROCESSOR_BALANCE_CHECK_FAILED";
    AfriexErrorCode["ProcessorBalanceLow"] = "PROCESSOR_BALANCE_LOW";
    AfriexErrorCode["ProcessorNotFound"] = "PROCESSOR_NOT_FOUND";
    AfriexErrorCode["ProcessorNotSupported"] = "PROCESSOR_NOT_SUPPORTED";
    AfriexErrorCode["OTPExpired"] = "OTP_EXPIRED";
    AfriexErrorCode["OTPNotNumeric"] = "OTP_NOT_NUMERIC";
    AfriexErrorCode["OTPIDInvalid"] = "OTP_ID_INVALID";
    AfriexErrorCode["OTPNotFound"] = "OTP_NOT_FOUND";
    AfriexErrorCode["OTPAlreadyUsed"] = "OTP_ALREADY_USED";
    AfriexErrorCode["OTPMismatch"] = "OTP_MISMATCH";
    AfriexErrorCode["OTPIncorrect"] = "OTP_INCORRECT";
    AfriexErrorCode["OTPAttemptExceeded"] = "OTP_ATTEMPT_EXCEEDED";
    AfriexErrorCode["AuthenticatorNotEnrolled"] = "AUTHENTICATOR_NOT_ENROLLED";
    AfriexErrorCode["AuthenticatorAlreadyEnrolled"] = "AUTHENTICATOR_ALREADY_ENROLLED";
    AfriexErrorCode["AuthenticatorNotEnabled"] = "AUTHENTICATOR_NOT_ENABLED";
    AfriexErrorCode["InvalidAuthenticatorCode"] = "INVALID_AUTHENTICATOR_CODE";
    AfriexErrorCode["FailedToSetupAuthenticator"] = "FAILED_TO_SETUP_AUTHENTICATOR";
    AfriexErrorCode["PaymentMethodIdMissing"] = "PAYMENT_METHOD_ID_MISSING";
    AfriexErrorCode["PaymentMethodUserIdMissing"] = "PAYMENT_METHOD_USER_ID_MISSING";
    AfriexErrorCode["PaymentMethodChannelMissing"] = "PAYMENT_METHOD_CHANNEL_MISSING";
    AfriexErrorCode["PaymentMethodChannelNotAllowed"] = "PAYMENT_METHOD_CHANNEL_NOT_ALLOWED";
    AfriexErrorCode["PaymentMethodBlocked"] = "PAYMENT_METHOD_BLOCKED";
    AfriexErrorCode["PaymentMethodCurrencyMismatch"] = "PAYMENT_METHOD_CURRENCY_MISMATCH";
    AfriexErrorCode["TransactionRatesNotFound"] = "TRANSACTION_RATES_NOT_FOUND";
    AfriexErrorCode["SourceCurrencySameAsTargetCurrency"] = "SOURCE_CURRENCY_SAME_AS_TARGET_CURRENCY";
    AfriexErrorCode["ThirdPartyError"] = "THIRD_PARTY_ERROR";
    AfriexErrorCode["TransactionFailed"] = "TRANSACTION_FAILED";
    AfriexErrorCode["TransactionPinNotFound"] = "TRANSACTION_PIN_NOT_FOUND";
    AfriexErrorCode["TransactionPinNotProvided"] = "TRANSACTION_PIN_NOT_PROVIDED";
    AfriexErrorCode["TransactionPinAttemptsExceeded"] = "TRANSACTION_PIN_ATTEMPTS_EXCEEDED";
    AfriexErrorCode["TransactionPinIncorrect"] = "TRANSACTION_PIN_INCORRECT";
    AfriexErrorCode["TransactionPinInvalid"] = "TRANSACTION_PIN_INVALID";
    AfriexErrorCode["TransactionPinHasSameDigits"] = "TRANSACTION_PIN_HAS_SAME_DIGITS";
    AfriexErrorCode["TransactionPinTooWeak"] = "TRANSACTION_PIN_TOO_WEAK";
    AfriexErrorCode["TransactionRequestDataMissing"] = "TRANSACTION_REQUEST_DATA_MISSING";
    AfriexErrorCode["TransactionRequestTypeMissing"] = "TRANSACTION_REQUEST_TYPE_MISSING";
    AfriexErrorCode["TransactionRequestTypeInvalid"] = "TRANSACTION_REQUEST_TYPE_INVALID";
    AfriexErrorCode["TransactionAmountMissing"] = "TRANSACTION_AMOUNT_MISSING";
    AfriexErrorCode["TransactionAmountInvalid"] = "TRANSACTION_AMOUNT_INVALID";
    AfriexErrorCode["TransactionAmountTooSmall"] = "TRANSACTION_AMOUNT_TOO_SMALL";
    AfriexErrorCode["TransactionAmountDoesNotCoverFee"] = "TRANSACTION_AMOUNT_DOES_NOT_COVER_FEE";
    AfriexErrorCode["TransactionAmountInvalidIncrement"] = "TRANSACTION_AMOUNT_INVALID_INCREMENT";
    AfriexErrorCode["TransactionCurrencyNotSupported"] = "TRANSACTION_CURRENCY_NOT_SUPPORTED";
    AfriexErrorCode["TransactionCurrencyMissing"] = "TRANSACTION_CURRENCY_MISSING";
    AfriexErrorCode["TransactionUserIdMissing"] = "TRANSACTION_USER_ID_MISSING";
    AfriexErrorCode["TransactionProcessorNotFound"] = "TRANSACTION_PROCESSOR_NOT_FOUND";
    AfriexErrorCode["TransactionLimitExceeded"] = "TRANSACTION_LIMIT_EXCEEDED";
    AfriexErrorCode["BusinessTransactionMinAmountNotMet"] = "BUSINESS_TRANSACTION_MIN_AMOUNT_NOT_MET";
    AfriexErrorCode["BusinessTransactionMaxAmountExceeded"] = "BUSINESS_TRANSACTION_MAX_AMOUNT_EXCEEDED";
    AfriexErrorCode["BusinessTransactionDailyLimitExceeded"] = "BUSINESS_TRANSACTION_DAILY_LIMIT_EXCEEDED";
    // Payout blocked because settling its fee would push the business Fee wallet
    // past its allowed overdraft limit. Withdrawals stay suspended until the
    // outstanding fee balance is topped up (deposits/collections are unaffected).
    AfriexErrorCode["BusinessFeeWalletOverdraftLimitExceeded"] = "BUSINESS_FEE_WALLET_OVERDRAFT_LIMIT_EXCEEDED";
    // A post-funding-approved withdrawal would push the business's aggregate
    // (USD-equivalent, across all currencies) negative Withdraw-wallet balance
    // past its approved limit.
    AfriexErrorCode["BusinessPostFundingLimitExceeded"] = "BUSINESS_POST_FUNDING_LIMIT_EXCEEDED";
    // Withdrawals are suspended because the business's negative Withdraw-wallet
    // balance persisted through the daily post-funding check. Stays suspended
    // until the balance is no longer negative (deposits/collections are
    // unaffected).
    AfriexErrorCode["BusinessWithdrawalsBlockedPostFunding"] = "BUSINESS_WITHDRAWALS_BLOCKED_POST_FUNDING";
    AfriexErrorCode["TransactionNotFound"] = "TRANSACTION_NOT_FOUND";
    AfriexErrorCode["TooManyInstallsOnDevice"] = "TOO_MANY_INSTALLS_ON_DEVICE";
    AfriexErrorCode["UnknownError"] = "UNKNOWN_ERROR";
    AfriexErrorCode["UserNotVerified"] = "USER_NOT_VERIFIED";
    AfriexErrorCode["BusinessNotVerified"] = "BUSINESS_NOT_VERIFIED";
    AfriexErrorCode["UserNotFound"] = "USER_NOT_FOUND";
    AfriexErrorCode["UserNotAMerchant"] = "USER_NOT_A_MERCHANT";
    AfriexErrorCode["UserFlagged"] = "USER_UNDER_REVIEW";
    AfriexErrorCode["UserAccountDeactivated"] = "USER_ACCOUNT_DEACTIVATED";
    AfriexErrorCode["WeakPassword"] = "WEAK_PASSWORD";
    AfriexErrorCode["ValidationError"] = "VALIDATION_ERROR";
    AfriexErrorCode["VirtualAccountLimitReached"] = "VIRTUAL_ACCOUNT_LIMIT_REACHED";
    AfriexErrorCode["UnsupportedVirtualAccountType"] = "UNSUPPORTED_VIRTUAL_ACCOUNT_TYPE";
    AfriexErrorCode["VirtualAccountPendingComplianceReview"] = "VIRTUAL_ACCOUNT_PENDING_COMPLIANCE_REVIEW";
    AfriexErrorCode["UnsupportedVirtualAccountCurrency"] = "UNSUPPORTED_VIRTUAL_ACCOUNT_CURRENCY";
    AfriexErrorCode["VirtualAccountBvnRequired"] = "VIRTUAL_ACCOUNT_BVN_REQUIRED";
    AfriexErrorCode["AuthorizationError"] = "AUTHORIZATION_ERROR";
    AfriexErrorCode["BadRequestError"] = "BAD_REQUEST_ERROR";
    AfriexErrorCode["BlockedByFirewall"] = "BLOCKED_BY_FIREWALL";
    AfriexErrorCode["ExistingEmailProvided"] = "EXISTING_EMAIL_PROVIDED";
    AfriexErrorCode["ExistingPhoneProvided"] = "EXISTING_PHONE_PROVIDED";
    AfriexErrorCode["FailedToConnect"] = "FAILED_TO_CONNECT";
    AfriexErrorCode["FailedToCreateStripeAccount"] = "FAILED_TO_CREATE_STRIPE_ACCOUNT";
    AfriexErrorCode["FailedToCreateStripeCustomer"] = "FAILED_TO_CREATE_STRIPE_CUSTOMER";
    AfriexErrorCode["FailedToFetchPerson"] = "FAILED_TO_FETCH_PERSON";
    AfriexErrorCode["FailedToGenerateToken"] = "FAILED_TO_GENERATE_TOKEN";
    AfriexErrorCode["FailedToGetSignedURL"] = "FAILED_TO_GET_SIGNED_URL";
    AfriexErrorCode["FailedToSaveNonce"] = "FAILED_TO_SAVE_NONCE";
    AfriexErrorCode["FailedToSavePerson"] = "FAILED_TO_SAVE_PERSON";
    AfriexErrorCode["FailedToSaveToRedis"] = "FAILED_TO_SAVE_TO_REDIS";
    AfriexErrorCode["FailedToSignup"] = "FAILED_TO_SIGNUP";
    AfriexErrorCode["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    AfriexErrorCode["ServiceUnavailable"] = "SERVICE_UNAVAILABLE";
    AfriexErrorCode["InvalidEmailProvided"] = "INVALID_EMAIL_PROVIDED";
    AfriexErrorCode["InvalidNameProvided"] = "INVALID_NAME_PROVIDED";
    AfriexErrorCode["InvalidNonceProvided"] = "INVALID_NONCE_PROVIDED";
    AfriexErrorCode["InvalidPasswordProvided"] = "INVALID_PASSWORD_PROVIDED";
    AfriexErrorCode["InvalidPhoneProvided"] = "INVALID_PHONE_PROVIDED";
    AfriexErrorCode["LoginAttemptUpdateFailed"] = "LOGIN_ATTEMPT_UPDATE_FAILED";
    AfriexErrorCode["LoginAttemptsExceeded"] = "LOGIN_ATTEMPTS_EXCEEDED";
    AfriexErrorCode["LoginPinUpdateFailed"] = "LOGIN_PIN_UPDATE_FAILED";
    AfriexErrorCode["NetworkError"] = "NETWORK_ERROR";
    AfriexErrorCode["NotFoundError"] = "NOT_FOUND_ERROR";
    AfriexErrorCode["NotSupportedError"] = "NOT_SUPPORTED_ERROR";
    AfriexErrorCode["PasswordMismatch"] = "PASSWORD_MISMATCH";
    AfriexErrorCode["UnknownDevice"] = "UNKNOWN_DEVICE";
})(AfriexErrorCode || (AfriexErrorCode = {}));
//# sourceMappingURL=AfriexErrorCode.js.map